import { useEffect } from "react";
import ReactGA from "react-ga4";

const GoogleAnalytics = () => {
  useEffect(() => {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

    if (!measurementId) {
      return;
    }

    ReactGA.initialize(measurementId);
  }, []);

  return <></>;
};

export default GoogleAnalytics;